/* eslint-disable react/destructuring-assignment */
import React, { ChangeEvent } from 'react'
import { Flex, FlexProps, forwardRef, Select, SelectProps, Text } from '~/design_system'
import useUuid from '~/hooks/useUuid'
import { Msg } from '../../../../common/localizationUtils'
import { Optional } from '../../../../common/types'
import { CaretDown } from '../../../../icons'
import { useActionBarContext } from './ActionBar.hook'

export type SortBySelectProps = Omit<FlexProps, 'onChange'> &
  Omit<SelectProps, 'value' | 'onChange'> & {
    value: string
    onChange: (value: string) => void
    'data-testid'?: string
  }
export const SortBy = forwardRef<Optional<SortBySelectProps, 'value' | 'onChange'>, 'select'>(
  ({ value: _value, onChange: _onChange, children, ...props }, ref) => {
    const {
      rootProps,
      placeholder,
      icon,
      iconSize,
      iconColor,
      'data-testid': dataTestId = 'action-bar-sortby',
      ...flexProps
    } = props
    const selectProps = { rootProps, placeholder, iconSize, iconColor }
    const { ordering: orderingContext } = useActionBarContext()
    const value = _value ?? orderingContext?.value
    const onChange = _onChange ?? orderingContext?.onChange
    const labelId = useUuid()

    return (
      <Flex data-action-bar-sort alignItems="center" gap={2} {...flexProps}>
        <Text as="label" textStyle="bodySmall" whiteSpace="nowrap" id={labelId}>
          <Msg id="common.ui.sort" description="Sort" />
        </Text>
        <Select
          ref={ref}
          data-testid={dataTestId}
          aria-labelledby={labelId}
          value={value}
          onChange={(e: ChangeEvent<HTMLSelectElement>) => onChange!(e.target.value)}
          textStyle="bodySmall"
          icon={icon ?? <CaretDown />}
          sx={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}
          {...selectProps}>
          {children}
        </Select>
      </Flex>
    )
  }
)
